import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const CTA = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-gradient-to-r from-red-500 to-pink-600 text-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            {t.cta.title}
          </h2>
          <p className="text-xl md:text-2xl mb-4 text-red-50">
            {t.cta.subtitle}
          </p>
          <p className="text-lg md:text-xl mb-10 text-red-100 max-w-2xl mx-auto">
            {t.cta.description}
          </p>
          <div className="flex justify-center items-center">
            <a
              href="/s"
              className="bg-white text-red-600 hover:bg-gray-100 font-bold py-4 px-10 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl"
            >
              {t.cta.button}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
